import React from 'react';
import clsx from 'clsx';
import { Tag, TagProps } from '../Tag';

export interface SelectTagProps
  extends Omit<TagProps<'div'>, 'component' | 'size'> {}

export function SelectTag({ className, ...props }: SelectTagProps) {
  return (
    <Tag
      {...props}
      className={clsx(
        'hse-Select__multipleValue',
        {
          'hse-Select__multipleValue_disabled': props.disabled
        },
        className
      )}
      component={'div'}
      size={Tag.Size.small}
    />
  );
}
